import Image from 'next/image';
const PaymentSteps = () => {
    const steps = [
        {
            id: 1,
            title: 'Step 1',
            color: 'bg-[#0086E6]',
            content: 'Fill out the form with your details and the payment amount.',
        },
        {
            id: 2,
            title: 'Step 2',
            color: 'bg-[#8ABC00]',
            content: 'Submit the form. You will be redirected to the PayPal payment gateway.',
        },
        {
            id: 3,
            title: 'Step 3',
            color: 'bg-[#0086E6]',
            isOptions: true,
            content: 'Choose one of the following payment options:',
        },
    ];

    return (
        <div className="md:pt-[40px] pt-[20px]">
            <div className=" grid grid-cols-1 lg:grid-cols-3  md:gap-[30px] gap-[15px]">
                {steps.map((step) => (
                    <div
                        key={step.id}
                        className={`min-h-[300px] relative bg-white overflow-hidden  flex flex-col items-center ${step.id === 3 ? 'p-[0_16px_35px_16px]' : 'md:p-[0_36px_36px_36px] p-[0_16px_35px_16px]'} text-center shadow-sm 
                            bg-cover bg-center bg-no-repeat`}
                        style={{
                            backgroundImage: `url(${step.id === 2 ? '/images/payment-step-2-bg.png' : '/images/payment-step-1-bg.png'})`
                        }}
                    >
                        <div
                            className="absolute top-0 left-0 w-full h-[2px]"
                            style={{ backgroundColor: step.id === 2 ? '#8CC63F' : '#0081E4' }}
                        />
                        {/* Step Badge */}
                        <div className={`text-white p-[6px_35px] text-subtitle-4 font-medium mb-[30px] z-10 ${step.color}`}>
                            {step.title}
                        </div>

                        {/* Main Content */}
                        <div className="flex-1 flex flex-col justify-center z-10">
                            <p className={`text-[#040405] font-[600] text-subtitle-1 xl:mb-[32px] mb-[15px] leading-[1.4]`}>
                                {step.content}
                            </p>

                            {step.isOptions && (
                                <div className="space-y-4 w-full  mx-auto px-[16px]">
                                    <div className="border-2 border-[#B0D9F7]  xl:p-[16px] p-[10px] flex items-start gap-[14px] bg-white">
                                        <Image src="/images/paypal-icon.svg" alt="PayPal" width={26} height={32} className="xl:w-[26px] xl:h-[32px] w-[20px] h-[25px]" />
                                        <p className="text-left text-subtitle-3 font-[600] text-[#32343B] leading-[1.4]">
                                            Pay using your PayPal account by logging in.
                                        </p>
                                    </div>

                                    <div className="text-[#54AEEE] font-[700] text-subtitle-3 xl:my-[18px] my-[10px] leading-[1]">OR</div>

                                    {/* Credit Card Option */}
                                    <div className="border-2 border-[#C9E08A]  xl:p-[14px] p-[10px] flex items-start gap-3 bg-white">
                                        <Image src="/images/credit-debit-card.svg" alt="credit-debit-card.svg" width={32} height={32} className="xl:w-[32px] xl:h-[32px] w-[25px] h-[25px]" />
                                        <div className="text-left">
                                            <p className="text-left text-subtitle-3 font-[600] text-[#32343B] leading-[1.4] ">
                                                Credit/Debit Card
                                            </p>
                                            <p className="text-left text-subtitle-4 text-[#32343B] leading-[1.4] mt-[7px]">
                                                Pay with a Debit or Credit Card (no PayPal account required). Simply select &quot;Pay with Debit or Credit Card&quot;, enter your card details, and complete the payment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Bottom Border */}
                        <div
                            className="absolute bottom-0 left-0 w-full h-[2px]"
                            style={{ backgroundColor: step.id === 2 ? '#8CC63F' : '#0081E4' }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PaymentSteps;